import { render, staticRenderFns } from "./Featured.vue?vue&type=template&id=5013e564&scoped=true&"
import script from "./Featured.vue?vue&type=script&lang=js&"
export * from "./Featured.vue?vue&type=script&lang=js&"
import style0 from "./Featured.vue?vue&type=style&index=0&id=5013e564&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5013e564",
  null
  
)

component.options.__file = "Featured.vue"
export default component.exports